import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { productItems } from 'config/productItems';
import kebabCase from 'lodash/kebabCase';
import { appTypePretty } from 'config/appTypes';
import { SideBarContext, initialSideBarState } from 'context/sidebarContextWrapper';
import { hasProductFromString } from 'utils/helpers'
import CompatibleNotice from './CompatibleNotice.component';
import {compatible, compatibleItem, link } from './Compatible.module.scss';

const productData = {};
productItems.forEach(item => {
  productData[`${item.name.toLowerCase()}`] = {
    name: item.name,
    link: item.link,
    versions: item?.versions,
  };
});


const CompatibleDisplay = ({ 
  product = '', 
  productVersion = [], 
  appType = null,
  fusionVersion = null,
  connectorVersion = null
}) => {

  const state = useContext(SideBarContext) || initialSideBarState;

  const hasProduct = hasProductFromString(product, state.currentProduct.tag)
  const isCompatibleAppType = appType ? appType.includes(kebabCase(state.currentProduct.value)) : true

  const getValidVersion = productObj => {
    if(productObj?.versions === undefined) return productObj.link;
    if (productObj.versions.includes(state.currentVersion)) {
      return productObj.link.replace(/\$(\w+)/, state.currentVersion);
    }
    return productObj.link.replace(/\$(\w+)/, productObj.versions[productObj.versions.length - 1]);
  };


  return (
    (product || productVersion || fusionVersion || connectorVersion) && (
      <aside className={compatible}>
        {productVersion && (
          <p className={compatibleItem}>
            Compatible versions:{' '}
            {productVersion.map((item, idx) =>
              idx < productVersion?.length - 1 ? `${item}, ` : `${item}`,
            )}
            <CompatibleNotice
              title="This article is not compatible with your selected version."
              showNotice={!productVersion.includes(state.currentVersion)}
            />
          </p>
        )}


        {product && (
          <p className={compatibleItem}>
            Works with:{' '}
            {appType ? appType.map((item, idx) => {
                  return <span key={item}>{appTypePretty[item]}{idx + 1 < appType?.length && ', '}</span>
                }) 
                  :
                product.split(', ').map((item, idx) => {
                  const productItem = productData[item.replace(/-/g, ' ')];
                  if (idx < product.split(', ')?.length - 1) {
                    return (
                      <>
                        <Link to={getValidVersion(productItem)} key={item} className={link}>
                          {productItem.name}
                        </Link>
                        {', '}
                      </>
                    );
                  }
                  return (
                    <Link to={getValidVersion(productItem)} key={item} className={link}>
                      {productItem.name}
                    </Link>
                  );
                })
            }

            <CompatibleNotice
              title="This article is not compatible with your selected product."
              showNotice={!hasProduct || !isCompatibleAppType}
            />  
          </p>
        )}

        {connectorVersion && (
          <p className={compatibleItem}>
            {`Latest version: ${connectorVersion}`}
          </p>
        )}

        {fusionVersion && (
          <p className={compatibleItem}>
            Compatible with Fusion version:
            {fusionVersion?.length === 1 ? ` ${fusionVersion[0]} and later` : ` ${fusionVersion[0]} through ${fusionVersion[1]}`}
          </p>
        )}

      </aside>
    )
  );
};

CompatibleDisplay.propTypes = {
  product: PropTypes.string,
  productVersion: PropTypes.array,
  appType: PropTypes.array,
  fusionVersion: PropTypes.string,
  connectorVersion: PropTypes.string
};

export default CompatibleDisplay;
